export enum ModalSize {
  HUGE,
  BIG,
  SMALL,
}
